import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { WidgetsOutlined } from '@material-ui/icons';
import { useCompany, useUser } from 'models';
import Can from 'components/Can';
import SectionElite from './components/SectionElite';
import SectionMasterAgent from './components/SectionMasterAgent';
import SectionEliteOld from './components/SectionEliteOld';
import SectionElitePass from './components/SectionElitePass';
import SectionOthers from './components/SectionOthers';
import SectionScansourceSelect from './components/SectionScansourceSelect';

export default function(){
  const user = useUser()
  const { company } = useCompany()
  const { id: fiscalYear } = JSON.parse(localStorage.getItem("Elite:fiscalYear")) || { }
  
  const isElite = () => {
    if (company && getCompanyFiscalYear()) {
      return getCompanyFiscalYear().is_premium
    } 
    else {
      return user.isElite()
    }
  }

  const isMasterAgent = () => {
    if (company && getCompanyFiscalYear()) {
      return getCompanyFiscalYear().is_masteragent
    }
    else { 
      return user.isMasterAgent();
    }
  };
  
  const getCompanyFiscalYear = () => {
    if (company && company.adhesion && company.adhesion.length > 0) {
      const { fiscal_year_id } = company.adhesion.map(adhesion => ({ fiscal_year_id: adhesion.fiscal_year_id }))[0]
      const cfy = company.all_company_fiscal_years.find(year => fiscal_year_id == year.fiscal_year_id)
      return cfy
    } 
    else {
      return { is_premium: company.is_premium, is_masteragent: company.is_masteragent }
    }
  }

  const renderCards = () => {
    if (user.profile.profile_type_id == 1) {
      return (
        <>
          <SectionScansourceSelect/>
          <SectionElitePass />
          <SectionElite />
        </>
      ) 
    }

    if (!!company && fiscalYear >= 14) {
      return <SectionScansourceSelect />
    }
    
    //if (!!company && fiscalYear == 12) {
      // return <SectionElite />
    //}

    if (!!company && fiscalYear == 13) {
      return <SectionElitePass />
    }
  }

  return (
    <Container className="mb-5">
      <Row className="col-12 mt-4 row">
        <WidgetsOutlined className="icon-title" />
        <h5 className="title-dashboard">Programas</h5>
      </Row>
      
      {isElite() ? (
        <>
          <Can do="elite.index" on="App">
            {renderCards()}        
            {user.profile.profile_type_id == 1 && <SectionOthers />}
          </Can>
          <Can do="elite.index.old" on="App">
            <SectionEliteOld fiscalYear="2023"/>
          </Can>
        </>
      ):(<></>)}

      {isMasterAgent() ? (
        <Can do="masterAgent.index" on="App">
          <SectionMasterAgent />
        </Can>
      ) : (<></>)}
    </Container>
  );
};
